module.exports = __webpack_public_path__ + "img/facebook.b7a41ef.svg";